import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hostedVideoActions, hostedVideoSelectors } from '../../../store/modules/hostedVideo';

import { CreateUploadProps, uploadsActions } from '@anm/store/modules/uploads';
import useProgressListener from '@anm/store/modules/uploads/hooks/useProgressListener';

export const useUploadRetry = (params?: CreateUploadProps) => {
  //todo: fix retry if needed
  const [iterationCount, setIterationCount] = useState(1);

  const canRetry = useSelector(hostedVideoSelectors.selectCanRetryCreateVideo);
  const createVideoPending = useSelector(hostedVideoSelectors.selectCreatedVideoPending);

  const dispatch = useDispatch();

  const RETRY_LIMIT = 3;

  const listener = useProgressListener();

  const createVideo = (params: CreateUploadProps) => {
    dispatch(
      uploadsActions.createUpload({
        ...params,
        progressListener: listener
      })
    );
  };

  useEffect(() => {
    if (!params || !canRetry || createVideoPending || iterationCount === RETRY_LIMIT) return;

    const timeOut = setTimeout(() => {
      dispatch(hostedVideoActions.clearCreatedVideo());
      createVideo(params);
      setIterationCount(count => count + 1);
    }, 1000);

    return () => clearTimeout(timeOut);
  }, [canRetry, params, iterationCount, createVideoPending]);

  useEffect(() => {
    if (iterationCount === RETRY_LIMIT && canRetry && !createVideoPending) {
      dispatch(
        hostedVideoActions.createFileError({
          code: 777,
          message: 'Something went wrong. Please try again!'
        })
      );
      setIterationCount(1);
    }
  }, [iterationCount, canRetry, createVideoPending]);

  return createVideo;
};
